module.exports = __webpack_public_path__ + "img/sopa.03d95f4f.svg";